var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from 'axios';
// Set config defaults when creating the instance
var httpRequest = axios.create({
    baseURL: process.env.REACT_APP_PROVIDER_URL,
    headers: __assign({ countryCode: process.env.REACT_APP_COUNTRYCODE, languageCode: process.env.REACT_APP_LANGUAGECODE }, ('REACT_APP_EXTERNAL_NAME' in process.env && {
        externalName: process.env.REACT_APP_EXTERNAL_NAME
    }))
});
var resInterceptor = function (res) {
    return res;
};
httpRequest.interceptors.response.use(resInterceptor, function (err) {
    return Promise.resolve(err === null || err === void 0 ? void 0 : err.response);
});
export default httpRequest;
